import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'tags', 'hidden']

  add(event) {
    if (event.key !== 'Enter') return
    event.preventDefault()
    this.addTag()
  }

  addFromButton() {
    this.addTag()
  }

  addTag() {
    const value = this.inputTarget.value.trim()
    if (!value) return

    const existing = this.getTags()
    if (existing.includes(value)) {
      this.inputTarget.value = ''
      return
    }

    const tag = document.createElement('span')
    tag.className = 'inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full'
    tag.innerHTML = `${this.escapeHtml(value)} <button type="button" class="text-blue-600 hover:text-blue-800" data-action="click->tag-input#remove">✕</button>`

    this.tagsTarget.appendChild(tag)
    this.inputTarget.value = ''
    this.updateHidden()
  }

  remove(event) {
    event.target.closest('span').remove()
    this.updateHidden()
  }

  getTags() {
    return Array.from(this.tagsTarget.querySelectorAll('span'))
      .map(span => span.textContent.replace('✕', '').trim())
  }

  updateHidden() {
    this.hiddenTarget.value = this.getTags().join(',')
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
